import {FC, useState, useEffect} from 'react'
import {useFormContext} from 'react-hook-form'
import {
  SelectWrapper,
  InputTextWrapper,
  InputDateWrapper,
} from '../../../../../../components/UI/Form/Input'
import HeaderTitle from '../../../componentes/Form/Header'
import {getEquipmentById, getSupplier, getLegalRepresentative, getPoint} from '../../../../services'
import {getCompany} from '../../../../../central/services'
import {useLavanderia} from '../../../../../../hooks/useLavanderia'
import {TabLavanderiaModel} from '../../../../../../models'
import {EquipmentModel, SelectModel, SupplierModel, PointModel} from '../../../../model'
import {CompanyModel} from '../../../../../central/model'
import {TITLE_FORM_EQUIPMENT} from '../../../../util/Constants'
import {initValues} from '../../../../util/values/equipment'
import AditionalForm from '../../../../../../components/UI/Form/aditionalCamp/aditionalCampCentral'
import useClientListService from '../../../../../central/hooks/useClientService'
import useSiteListService from '../../../../../central/hooks/useSiteService'
import useCampListService from '../../../../../central/hooks/useCampService'
import {clearFields} from '../../../../../../util/functions'
import {useTableMaster} from '../../../../hooks'
const Equipment: FC = () => {
  const {setError, setValue, watch, reset} = useFormContext()
  const {currentTabItem, changeCurrentTabItem} = useLavanderia()
  const [infoSupplier, setInfoSupplier] = useState<SelectModel | any>(null)
  const [company, setCompany] = useState<SelectModel[]>([])
  const [supplier, setSupplier] = useState<SelectModel[]>([])
  const [machine, setMachine] = useState<SelectModel[]>([])
  const {frecuency, getFrecuencyList, statusOperational, getStatusOperationalList} =
    useTableMaster()
  const {clientList, getClientList} = useClientListService()
  const {siteList, getSiteList} = useSiteListService()
  const {campList, getCampList} = useCampListService()

  const getPointList = async () => {
    let obj: PointModel = {
      isCombo: true,
      companiaId: watch('companiaId'),
      clienteId: watch('clienteId'),
      siteId: watch('siteId'),
      campamentoId: watch('campamentoId'),
    }
    const response = await getPoint(obj, 1)
    const data = response.data.data
    const mappedSites = data.map((item) => ({value: item.id, label: item.nombre}))
    setMachine(mappedSites)
  }
  const getCompanyList = async () => {
    let obj: CompanyModel = {
      isCombo: true,
    }
    const response = await getCompany(obj, 1)
    const data = response.data.data
    const mappedSites = data.map((item) => ({value: item.id, label: item.nombreEmpresa}))
    setCompany(mappedSites)
  }

  const getSupplierList = async () => {
    let obj: SupplierModel = {
      isCombo: true,
    }
    const response = await getSupplier(obj, 1)
    const data = response.data.data
    const mappedSites = data.map((item) => ({
      value: item.id,
      label: item.razonSocial,
    }))
    setSupplier(mappedSites)
  }

  const getLegalRepresentativeList = async (id: any) => {
    try {
      const response = await getLegalRepresentative({proveedorId: id}, 1)
      const data = response.data.data
      const isInterlocutor = data?.filter((item) => item.esInterlocutor)[0] || null
      setInfoSupplier(isInterlocutor)
      if (isInterlocutor) {
        setValue('proveedorNombre', isInterlocutor.nombres)
        setValue('proveedorApellido', isInterlocutor.apellidoPaterno)
        setValue('proveedorCelular', isInterlocutor.telefono)
        setValue('proveedorCorreo', isInterlocutor.email)
      }
    } catch (error) {
      console.error('Error al obtener la lista de tipo de documento:', error)
    }
  }
  const getEquipmentByIdValues = async () => {
    const response = await getEquipmentById(currentTabItem.idToEdit)
    const data = response.data.data
    type EquipmentModelKeys = keyof EquipmentModel

    for (const fieldName in initValues) {
      if (initValues.hasOwnProperty(fieldName)) {
        if (data.hasOwnProperty(fieldName)) {
          if (data[fieldName as EquipmentModelKeys]) {
            if (fieldName === 'clienteId') {
              let valueCompania = data['companiaId']
              let valueClient = data['clienteId']
              getClientList({companiaId: valueCompania})
              setValue('clienteId', valueClient)
            } else if (fieldName === 'siteId') {
              let valueSite = data['siteId']
              let valueClient = data['clienteId']
              getSiteList({clienteId: valueClient})
              setValue('siteId', valueSite)
            } else if (fieldName === 'campamentoId') {
              let valueSite = data['campamentoId']
              let valueClient = data['siteId']
              getCampList({siteId: valueClient})
              setValue('campamentoId', valueSite)
              getPointList()
            } else if (fieldName === 'proveedorId') {
              let valueProvedor = data['proveedorId']
              getLegalRepresentativeList(valueProvedor)
              setValue('proveedorId', valueProvedor)
            } else if (fieldName === 'fabricacion') {
              let valueDep = data[fieldName as EquipmentModelKeys]
              if (valueDep !== null && valueDep !== undefined && typeof valueDep === 'string') {
                const fechaLocal = new Date(valueDep)
                const formattedDate = fechaLocal.toISOString().slice(0, 10)
                setValue(fieldName, formattedDate)
              }
            } else if (fieldName === 'instalacion') {
              let valueDep = data[fieldName as EquipmentModelKeys]
              if (valueDep !== null && valueDep !== undefined && typeof valueDep === 'string') {
                const fechaLocal = new Date(valueDep)
                const formattedDate = fechaLocal.toISOString().slice(0, 10)
                setValue(fieldName, formattedDate)
              }
            } else if (fieldName === 'ultimoMantenimiento') {
              let valueDep = data[fieldName as EquipmentModelKeys]
              if (valueDep !== null && valueDep !== undefined && typeof valueDep === 'string') {
                const fechaLocal = new Date(valueDep)
                const formattedDate = fechaLocal.toISOString().slice(0, 10)
                setValue(fieldName, formattedDate)
              }
            } else if (fieldName === 'campoadicionalFec1') {
              let valueDep = data[fieldName as EquipmentModelKeys]
              if (valueDep !== null && valueDep !== undefined && typeof valueDep === 'string') {
                const fechaLocal = new Date(valueDep)
                const formattedDate = fechaLocal.toISOString().slice(0, 10)
                setValue(fieldName, formattedDate)
              }
            } else if (fieldName === 'campoadicionalFec2') {
              let valueDep = data[fieldName as EquipmentModelKeys]
              if (valueDep !== null && valueDep !== undefined && typeof valueDep === 'string') {
                const fechaLocal = new Date(valueDep)
                const formattedDate = fechaLocal.toISOString().slice(0, 10)
                setValue(fieldName, formattedDate)
              }
            } else {
              setValue(fieldName, data[fieldName as EquipmentModelKeys])
            }
          } else {
            setValue(fieldName, '')
          }
        }
      }
    }
  }

  useEffect(() => {
    getCompanyList()
    getSupplierList()
    getFrecuencyList()
    getStatusOperationalList()
  }, [])

  useEffect(() => {
    if (currentTabItem.idToEdit) {
      getEquipmentByIdValues()
    }
  }, [currentTabItem.idToEdit])

  const handleBack = () => {
    const obj: TabLavanderiaModel = {
      ...currentTabItem,
      showPanel: false,
    }
    reset()
    changeCurrentTabItem(obj)
  }

  const handleGetClient = (e: any) => {
    let value = e.value
    getClientList({companiaId: value})
    setValue('companiaId', value)
    setError('companiaId', {})
    clearFields(setValue, setError, {
      clienteId: '',
      siteId: '',
      campamentoId: '',
    })
  }
  const handleGetSite = (e: any) => {
    let value = e.value
    getSiteList({clienteId: value})
    setValue('clienteId', value)
    setError('clienteId', {})
    clearFields(setValue, setError, {
      siteId: '',
      campamentoId: '',
    })
  }
  const handleGetCamp = (e: any) => {
    let value = e.value
    getCampList({siteId: value})
    setValue('siteId', value)
    setError('siteId', {})
    clearFields(setValue, setError, {
      campamentoId: '',
    })
  }
  const handleGetSupplier = async (e: any) => {
    let value = e.value
    setValue('proveedorId', value)
    setError('proveedorId', {})
    await getLegalRepresentativeList(value)
  }
  const handleGetPoint = (e: any) => {
    let value = e.value
    setValue('campamentoId', value)
    setError('campamentoId', {})
    getPointList()
  }
  let isDisabled = currentTabItem.idToEdit ? true : false
  return (
    <div className='sdx_form card p-4'>
      <HeaderTitle isEdit={isDisabled} title={TITLE_FORM_EQUIPMENT} handleBack={handleBack} />
      <div className='row'>
        <div className='col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Compañía'
            name='companiaId'
            data={company}
            disabled={isDisabled}
            onChangeValue={handleGetClient}
            required
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Cliente'
            name='clienteId'
            data={clientList}
            disabled={isDisabled}
            onChangeValue={handleGetSite}
            required
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Site'
            name='siteId'
            data={siteList}
            disabled={isDisabled}
            onChangeValue={handleGetCamp}
            required
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Campamento'
            name='campamentoId'
            data={campList}
            disabled={isDisabled}
            onChangeValue={handleGetPoint}
            required
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <InputTextWrapper
            labelText='Nomenclatura del Equipo'
            name='nombre'
            textPlaceholder='Escribe la nomenclatura'
            disabled={isDisabled}
            type='ticketNumber'
            required
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <InputTextWrapper
            labelText='Marca'
            name='marca'
            textPlaceholder='Escribe la marca'
            type='alphaNumeric'
            required
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <InputTextWrapper
            labelText='Modelo'
            name='modelo'
            textPlaceholder='Escribe el modelo'
            type='ticketNumber'
            required
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <InputDateWrapper labelText='Año de fabricación' name='fabricacion' />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <InputDateWrapper labelText='Año de instalación' name='instalacion' />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <InputTextWrapper
            labelText='Capacidad'
            name='capacidad'
            textPlaceholder='Escribe la capacidad'
            type='alphaNumeric'
            required
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <InputTextWrapper
            labelText='Serie'
            name='serie'
            textPlaceholder='Escribe la serie'
            type='ticketNumber'
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Proveedor de mantenimiento'
            name='proveedorId'
            data={supplier}
            onChangeValue={handleGetSupplier}
          />
        </div>
        {infoSupplier && (
          <div className='row col-sm-12 col-lg-12 my-2 py-2'>
            <div className='col-sm-12 col-lg-12 mb-2'>
              <h5>Contacto del Proveedor de mantenimiento</h5>
            </div>
            <div className='col-sm-12 col-lg-3'>
              <InputTextWrapper labelText='Nombre' name='proveedorNombre' disabled={true} />
            </div>
            <div className='col-sm-12 col-lg-3'>
              <InputTextWrapper labelText='Apellido' name='proveedorApellido' disabled={true} />
            </div>
            <div className='col-sm-12 col-lg-3'>
              <InputTextWrapper labelText='Celular' name='proveedorCelular' disabled={true} />
            </div>
            <div className='col-sm-12 col-lg-3'>
              <InputTextWrapper labelText='Correo' name='proveedorCorreo' disabled={true} />
            </div>
          </div>
        )}

        <div className='col-sm-12 col-lg-3'>
          <InputDateWrapper labelText='Fecha de último mantenimiento' name='ultimoMantenimiento' />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Frecuencia de mantenimiento'
            name='frecuenciaMantenimiento'
            data={frecuency}
            required
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Estado de operatividad'
            name='estado'
            data={statusOperational}
            required
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <SelectWrapper labelText='Asignar a punto de lavandería' name='puntoId' data={machine} />
        </div>
      </div>
      <hr className='divider' />
      <AditionalForm />
    </div>
  )
}

export default Equipment
